/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { ListingAnalytics } from '../model';
// @ts-ignore
import { ListingNetworksNotifyRequest } from '../model';
// @ts-ignore
import { ListingOrgArchiveRequest } from '../model';
// @ts-ignore
import { ListingOrgOverview } from '../model';
// @ts-ignore
import { ListingOrgSoldRequest } from '../model';
// @ts-ignore
import { ListingOrgWriteRequest } from '../model';
// @ts-ignore
import { ListingPriceGridBroadcastRequest } from '../model';
// @ts-ignore
import { ListingPublishAction } from '../model';
// @ts-ignore
import { ListingPublishActionRequest } from '../model';
// @ts-ignore
import { ListingRead } from '../model';
// @ts-ignore
import { PaginatedListingReadList } from '../model';
// @ts-ignore
import { PatchedListingOrgWriteRequest } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * MarketplaceOrgListingApi - axios parameter creator
 * @export
 */
export const MarketplaceOrgListingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * NOTE: some data may be delayed by up to an hour
         * @summary Analytics data for the Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date from. default to date_to - 13 days
         * @param {string} [dateTo] Date to. defaults to today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingAnalyticsList: async (buyerOrgId: string, listingId: string, aaSource?: string, dateFrom?: string, dateTo?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingAnalyticsList', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingAnalyticsList', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/analytics`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substr(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substr(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
         * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingAnalyticsSnoozeCreate: async (buyerOrgId: string, listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingAnalyticsSnoozeCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingAnalyticsSnoozeCreate', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/analytics/snooze`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
         * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingAnalyticsSnoozeDestroy: async (buyerOrgId: string, listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingAnalyticsSnoozeDestroy', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingAnalyticsSnoozeDestroy', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/analytics/snooze`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Archive the Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgArchiveRequest} listingOrgArchiveRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingArchiveCreate: async (buyerOrgId: string, listingId: string, listingOrgArchiveRequest: ListingOrgArchiveRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingArchiveCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingArchiveCreate', 'listingId', listingId)
            // verify required parameter 'listingOrgArchiveRequest' is not null or undefined
            assertParamExists('orgMarketplaceListingArchiveCreate', 'listingOrgArchiveRequest', listingOrgArchiveRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/archive`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingOrgArchiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the ARCHIVED status, returning it to DRAFT.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingArchiveDestroy: async (buyerOrgId: string, listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingArchiveDestroy', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingArchiveDestroy', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/archive`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * NOTE: A user can have the Grid bookmarked but if their visibility access changes on the grid then they will no longer be able to see it, and thus not get a notification.  eg. User is following the grid and the grid is Public, if the grid changes to Private Groups only and the user is NOT a Contact and in one of the Networks of the Org then they no longer have access and will NOT received a notification
         * @summary Broadcasts a message to the people following (bookmarked) the Listing\'s Grid
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingPriceGridBroadcastRequest} listingPriceGridBroadcastRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingBroadcastCreate: async (buyerOrgId: string, listingId: string, listingPriceGridBroadcastRequest: ListingPriceGridBroadcastRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingBroadcastCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingBroadcastCreate', 'listingId', listingId)
            // verify required parameter 'listingPriceGridBroadcastRequest' is not null or undefined
            assertParamExists('orgMarketplaceListingBroadcastCreate', 'listingPriceGridBroadcastRequest', listingPriceGridBroadcastRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/broadcast`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingPriceGridBroadcastRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Create a new Listing
         * @param {string} buyerOrgId 
         * @param {ListingOrgWriteRequest} listingOrgWriteRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingCreate: async (buyerOrgId: string, listingOrgWriteRequest: ListingOrgWriteRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingOrgWriteRequest' is not null or undefined
            assertParamExists('orgMarketplaceListingCreate', 'listingOrgWriteRequest', listingOrgWriteRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingOrgWriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Deletes a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingDestroy: async (buyerOrgId: string, listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingDestroy', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingDestroy', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admins can access all Listings within the Org, while regular staff members can only access the Listings they have created.  By default, if no visibility filter is passed through all ARCHIVED ones are not returned.
         * @summary Get a list of the Organisations Listings
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [live] Listings where visibility&#x3D;PRIVATE or PUBLIC
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network. Use &#x60;none&#x60; to return Listing that are not associated with any networks.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [_private] Listings where visibility&#x3D;PRIVATE
         * @param {string} [product] Product
         * @param {string} [_public] Listings where visibility&#x3D;PUBLIC
         * @param {'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW'} [publicStatus] Listings by the Public Status. Multiple values must be comma separated  * &#x60;DRAFT&#x60; - Draft * &#x60;REVIEW&#x60; - Under review * &#x60;REJECTED&#x60; - Rejected * &#x60;APPROVED&#x60; - Approved
         * @param {string} [sold] Listings that are sold
         * @param {'BUY' | 'SELL'} [type] Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {string} [underOffer] Listings that are under offer
         * @param {'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC'} [visibility] Listing visibility. Multiple values must be comma separated. By default, if no visibility parameter is passed through, the ARCHIVED state will be excluded.  * &#x60;DELETED&#x60; - Deleted * &#x60;ARCHIVED&#x60; - Archived * &#x60;EXPIRED&#x60; - Expired * &#x60;HIDDEN&#x60; - Hidden * &#x60;PRIVATE&#x60; - Private * &#x60;PUBLIC&#x60; - Public
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingList: async (buyerOrgId: string, aaSource?: string, live?: string, network?: string, page?: number, pageSize?: number, _private?: string, product?: string, _public?: string, publicStatus?: 'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW', sold?: string, type?: 'BUY' | 'SELL', underOffer?: string, visibility?: 'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }

            if (live !== undefined) {
                localVarQueryParameter['live'] = live;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (_private !== undefined) {
                localVarQueryParameter['private'] = _private;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (_public !== undefined) {
                localVarQueryParameter['public'] = _public;
            }

            if (publicStatus !== undefined) {
                localVarQueryParameter['public_status'] = publicStatus;
            }

            if (sold !== undefined) {
                localVarQueryParameter['sold'] = sold;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (underOffer !== undefined) {
                localVarQueryParameter['under_offer'] = underOffer;
            }

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Sends a push notification out to the Users who are within the Networks passed through.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingNetworksNotifyRequest} listingNetworksNotifyRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingNotifyCreate: async (buyerOrgId: string, listingId: string, listingNetworksNotifyRequest: ListingNetworksNotifyRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingNotifyCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingNotifyCreate', 'listingId', listingId)
            // verify required parameter 'listingNetworksNotifyRequest' is not null or undefined
            assertParamExists('orgMarketplaceListingNotifyCreate', 'listingNetworksNotifyRequest', listingNetworksNotifyRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/notify`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingNetworksNotifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Overview of the Listings associated with the Org and User
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingOverviewRetrieve: async (buyerOrgId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingOverviewRetrieve', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/overview`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only the keys passed through will be updated   Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Partially update the details of a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedListingOrgWriteRequest} [patchedListingOrgWriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingPartialUpdate: async (buyerOrgId: string, listingId: string, aaSource?: string, patchedListingOrgWriteRequest?: PatchedListingOrgWriteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingPartialUpdate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingPartialUpdate', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedListingOrgWriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Transition a Listing between PUBLIC and PRIVATE. It can go in either direction.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingPublishActionRequest} listingPublishActionRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingPublishCreate: async (buyerOrgId: string, listingId: string, listingPublishActionRequest: ListingPublishActionRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingPublishCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingPublishCreate', 'listingId', listingId)
            // verify required parameter 'listingPublishActionRequest' is not null or undefined
            assertParamExists('orgMarketplaceListingPublishCreate', 'listingPublishActionRequest', listingPublishActionRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/publish`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingPublishActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingRetrieve: async (buyerOrgId: string, listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingRetrieve', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingRetrieve', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Update the sold status of the listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgSoldRequest} listingOrgSoldRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingSoldCreate: async (buyerOrgId: string, listingId: string, listingOrgSoldRequest: ListingOrgSoldRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingSoldCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingSoldCreate', 'listingId', listingId)
            // verify required parameter 'listingOrgSoldRequest' is not null or undefined
            assertParamExists('orgMarketplaceListingSoldCreate', 'listingOrgSoldRequest', listingOrgSoldRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/sold`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingOrgSoldRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the sold status.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingSoldDestroy: async (buyerOrgId: string, listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingSoldDestroy', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingSoldDestroy', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/sold`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the under offer status.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingUnderOfferDestroy: async (buyerOrgId: string, listingId: string, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingUnderOfferDestroy', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingUnderOfferDestroy', 'listingId', listingId)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}/under-offer`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Update the details of a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgWriteRequest} listingOrgWriteRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingUpdate: async (buyerOrgId: string, listingId: string, listingOrgWriteRequest: ListingOrgWriteRequest, aaSource?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgMarketplaceListingUpdate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('orgMarketplaceListingUpdate', 'listingId', listingId)
            // verify required parameter 'listingOrgWriteRequest' is not null or undefined
            assertParamExists('orgMarketplaceListingUpdate', 'listingOrgWriteRequest', listingOrgWriteRequest)
            const localVarPath = `/v2/org/{buyer_org_id}/marketplace/listing/{listing_id}`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"listing_id"}}`, encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (aaSource !== undefined) {
                localVarQueryParameter['aa_source'] = aaSource;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listingOrgWriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketplaceOrgListingApi - functional programming interface
 * @export
 */
export const MarketplaceOrgListingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketplaceOrgListingApiAxiosParamCreator(configuration)
    return {
        /**
         * NOTE: some data may be delayed by up to an hour
         * @summary Analytics data for the Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date from. default to date_to - 13 days
         * @param {string} [dateTo] Date to. defaults to today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingAnalyticsList(buyerOrgId: string, listingId: string, aaSource?: string, dateFrom?: string, dateTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListingAnalytics>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingAnalyticsList(buyerOrgId, listingId, aaSource, dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
         * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingAnalyticsSnoozeCreate(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingAnalytics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingAnalyticsSnoozeCreate(buyerOrgId, listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
         * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingAnalyticsSnoozeDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingAnalytics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingAnalyticsSnoozeDestroy(buyerOrgId, listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Archive the Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgArchiveRequest} listingOrgArchiveRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingArchiveCreate(buyerOrgId: string, listingId: string, listingOrgArchiveRequest: ListingOrgArchiveRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingArchiveCreate(buyerOrgId, listingId, listingOrgArchiveRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the ARCHIVED status, returning it to DRAFT.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingArchiveDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingArchiveDestroy(buyerOrgId, listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * NOTE: A user can have the Grid bookmarked but if their visibility access changes on the grid then they will no longer be able to see it, and thus not get a notification.  eg. User is following the grid and the grid is Public, if the grid changes to Private Groups only and the user is NOT a Contact and in one of the Networks of the Org then they no longer have access and will NOT received a notification
         * @summary Broadcasts a message to the people following (bookmarked) the Listing\'s Grid
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingPriceGridBroadcastRequest} listingPriceGridBroadcastRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingBroadcastCreate(buyerOrgId: string, listingId: string, listingPriceGridBroadcastRequest: ListingPriceGridBroadcastRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingBroadcastCreate(buyerOrgId, listingId, listingPriceGridBroadcastRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Create a new Listing
         * @param {string} buyerOrgId 
         * @param {ListingOrgWriteRequest} listingOrgWriteRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingCreate(buyerOrgId: string, listingOrgWriteRequest: ListingOrgWriteRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingCreate(buyerOrgId, listingOrgWriteRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Deletes a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingDestroy(buyerOrgId, listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Admins can access all Listings within the Org, while regular staff members can only access the Listings they have created.  By default, if no visibility filter is passed through all ARCHIVED ones are not returned.
         * @summary Get a list of the Organisations Listings
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [live] Listings where visibility&#x3D;PRIVATE or PUBLIC
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network. Use &#x60;none&#x60; to return Listing that are not associated with any networks.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [_private] Listings where visibility&#x3D;PRIVATE
         * @param {string} [product] Product
         * @param {string} [_public] Listings where visibility&#x3D;PUBLIC
         * @param {'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW'} [publicStatus] Listings by the Public Status. Multiple values must be comma separated  * &#x60;DRAFT&#x60; - Draft * &#x60;REVIEW&#x60; - Under review * &#x60;REJECTED&#x60; - Rejected * &#x60;APPROVED&#x60; - Approved
         * @param {string} [sold] Listings that are sold
         * @param {'BUY' | 'SELL'} [type] Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {string} [underOffer] Listings that are under offer
         * @param {'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC'} [visibility] Listing visibility. Multiple values must be comma separated. By default, if no visibility parameter is passed through, the ARCHIVED state will be excluded.  * &#x60;DELETED&#x60; - Deleted * &#x60;ARCHIVED&#x60; - Archived * &#x60;EXPIRED&#x60; - Expired * &#x60;HIDDEN&#x60; - Hidden * &#x60;PRIVATE&#x60; - Private * &#x60;PUBLIC&#x60; - Public
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingList(buyerOrgId: string, aaSource?: string, live?: string, network?: string, page?: number, pageSize?: number, _private?: string, product?: string, _public?: string, publicStatus?: 'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW', sold?: string, type?: 'BUY' | 'SELL', underOffer?: string, visibility?: 'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListingReadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingList(buyerOrgId, aaSource, live, network, page, pageSize, _private, product, _public, publicStatus, sold, type, underOffer, visibility, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Sends a push notification out to the Users who are within the Networks passed through.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingNetworksNotifyRequest} listingNetworksNotifyRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingNotifyCreate(buyerOrgId: string, listingId: string, listingNetworksNotifyRequest: ListingNetworksNotifyRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingNotifyCreate(buyerOrgId, listingId, listingNetworksNotifyRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Overview of the Listings associated with the Org and User
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingOverviewRetrieve(buyerOrgId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingOrgOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingOverviewRetrieve(buyerOrgId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Only the keys passed through will be updated   Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Partially update the details of a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedListingOrgWriteRequest} [patchedListingOrgWriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingPartialUpdate(buyerOrgId: string, listingId: string, aaSource?: string, patchedListingOrgWriteRequest?: PatchedListingOrgWriteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingPartialUpdate(buyerOrgId, listingId, aaSource, patchedListingOrgWriteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Transition a Listing between PUBLIC and PRIVATE. It can go in either direction.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingPublishActionRequest} listingPublishActionRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingPublishCreate(buyerOrgId: string, listingId: string, listingPublishActionRequest: ListingPublishActionRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingPublishAction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingPublishCreate(buyerOrgId, listingId, listingPublishActionRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingRetrieve(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingRetrieve(buyerOrgId, listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Update the sold status of the listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgSoldRequest} listingOrgSoldRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingSoldCreate(buyerOrgId: string, listingId: string, listingOrgSoldRequest: ListingOrgSoldRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingSoldCreate(buyerOrgId, listingId, listingOrgSoldRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the sold status.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingSoldDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingSoldDestroy(buyerOrgId, listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the under offer status.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingUnderOfferDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingUnderOfferDestroy(buyerOrgId, listingId, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Update the details of a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgWriteRequest} listingOrgWriteRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgMarketplaceListingUpdate(buyerOrgId: string, listingId: string, listingOrgWriteRequest: ListingOrgWriteRequest, aaSource?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgMarketplaceListingUpdate(buyerOrgId, listingId, listingOrgWriteRequest, aaSource, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketplaceOrgListingApi - factory interface
 * @export
 */
export const MarketplaceOrgListingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketplaceOrgListingApiFp(configuration)
    return {
        /**
         * NOTE: some data may be delayed by up to an hour
         * @summary Analytics data for the Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [dateFrom] Date from. default to date_to - 13 days
         * @param {string} [dateTo] Date to. defaults to today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingAnalyticsList(buyerOrgId: string, listingId: string, aaSource?: string, dateFrom?: string, dateTo?: string, options?: any): AxiosPromise<Array<ListingAnalytics>> {
            return localVarFp.orgMarketplaceListingAnalyticsList(buyerOrgId, listingId, aaSource, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
         * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingAnalyticsSnoozeCreate(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): AxiosPromise<ListingAnalytics> {
            return localVarFp.orgMarketplaceListingAnalyticsSnoozeCreate(buyerOrgId, listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
         * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingAnalyticsSnoozeDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): AxiosPromise<ListingAnalytics> {
            return localVarFp.orgMarketplaceListingAnalyticsSnoozeDestroy(buyerOrgId, listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Archive the Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgArchiveRequest} listingOrgArchiveRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingArchiveCreate(buyerOrgId: string, listingId: string, listingOrgArchiveRequest: ListingOrgArchiveRequest, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingArchiveCreate(buyerOrgId, listingId, listingOrgArchiveRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the ARCHIVED status, returning it to DRAFT.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingArchiveDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingArchiveDestroy(buyerOrgId, listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * NOTE: A user can have the Grid bookmarked but if their visibility access changes on the grid then they will no longer be able to see it, and thus not get a notification.  eg. User is following the grid and the grid is Public, if the grid changes to Private Groups only and the user is NOT a Contact and in one of the Networks of the Org then they no longer have access and will NOT received a notification
         * @summary Broadcasts a message to the people following (bookmarked) the Listing\'s Grid
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingPriceGridBroadcastRequest} listingPriceGridBroadcastRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingBroadcastCreate(buyerOrgId: string, listingId: string, listingPriceGridBroadcastRequest: ListingPriceGridBroadcastRequest, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orgMarketplaceListingBroadcastCreate(buyerOrgId, listingId, listingPriceGridBroadcastRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Create a new Listing
         * @param {string} buyerOrgId 
         * @param {ListingOrgWriteRequest} listingOrgWriteRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingCreate(buyerOrgId: string, listingOrgWriteRequest: ListingOrgWriteRequest, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingCreate(buyerOrgId, listingOrgWriteRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Deletes a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orgMarketplaceListingDestroy(buyerOrgId, listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Admins can access all Listings within the Org, while regular staff members can only access the Listings they have created.  By default, if no visibility filter is passed through all ARCHIVED ones are not returned.
         * @summary Get a list of the Organisations Listings
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {string} [live] Listings where visibility&#x3D;PRIVATE or PUBLIC
         * @param {string} [network] Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network. Use &#x60;none&#x60; to return Listing that are not associated with any networks.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [_private] Listings where visibility&#x3D;PRIVATE
         * @param {string} [product] Product
         * @param {string} [_public] Listings where visibility&#x3D;PUBLIC
         * @param {'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW'} [publicStatus] Listings by the Public Status. Multiple values must be comma separated  * &#x60;DRAFT&#x60; - Draft * &#x60;REVIEW&#x60; - Under review * &#x60;REJECTED&#x60; - Rejected * &#x60;APPROVED&#x60; - Approved
         * @param {string} [sold] Listings that are sold
         * @param {'BUY' | 'SELL'} [type] Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
         * @param {string} [underOffer] Listings that are under offer
         * @param {'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC'} [visibility] Listing visibility. Multiple values must be comma separated. By default, if no visibility parameter is passed through, the ARCHIVED state will be excluded.  * &#x60;DELETED&#x60; - Deleted * &#x60;ARCHIVED&#x60; - Archived * &#x60;EXPIRED&#x60; - Expired * &#x60;HIDDEN&#x60; - Hidden * &#x60;PRIVATE&#x60; - Private * &#x60;PUBLIC&#x60; - Public
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingList(buyerOrgId: string, aaSource?: string, live?: string, network?: string, page?: number, pageSize?: number, _private?: string, product?: string, _public?: string, publicStatus?: 'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW', sold?: string, type?: 'BUY' | 'SELL', underOffer?: string, visibility?: 'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC', options?: any): AxiosPromise<PaginatedListingReadList> {
            return localVarFp.orgMarketplaceListingList(buyerOrgId, aaSource, live, network, page, pageSize, _private, product, _public, publicStatus, sold, type, underOffer, visibility, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Sends a push notification out to the Users who are within the Networks passed through.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingNetworksNotifyRequest} listingNetworksNotifyRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingNotifyCreate(buyerOrgId: string, listingId: string, listingNetworksNotifyRequest: ListingNetworksNotifyRequest, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingNotifyCreate(buyerOrgId, listingId, listingNetworksNotifyRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Overview of the Listings associated with the Org and User
         * @param {string} buyerOrgId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingOverviewRetrieve(buyerOrgId: string, aaSource?: string, options?: any): AxiosPromise<ListingOrgOverview> {
            return localVarFp.orgMarketplaceListingOverviewRetrieve(buyerOrgId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Only the keys passed through will be updated   Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Partially update the details of a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {PatchedListingOrgWriteRequest} [patchedListingOrgWriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingPartialUpdate(buyerOrgId: string, listingId: string, aaSource?: string, patchedListingOrgWriteRequest?: PatchedListingOrgWriteRequest, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingPartialUpdate(buyerOrgId, listingId, aaSource, patchedListingOrgWriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Transition a Listing between PUBLIC and PRIVATE. It can go in either direction.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingPublishActionRequest} listingPublishActionRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingPublishCreate(buyerOrgId: string, listingId: string, listingPublishActionRequest: ListingPublishActionRequest, aaSource?: string, options?: any): AxiosPromise<ListingPublishAction> {
            return localVarFp.orgMarketplaceListingPublishCreate(buyerOrgId, listingId, listingPublishActionRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingRetrieve(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingRetrieve(buyerOrgId, listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Update the sold status of the listing.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgSoldRequest} listingOrgSoldRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingSoldCreate(buyerOrgId: string, listingId: string, listingOrgSoldRequest: ListingOrgSoldRequest, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingSoldCreate(buyerOrgId, listingId, listingOrgSoldRequest, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the sold status.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingSoldDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingSoldDestroy(buyerOrgId, listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Delete the under offer status.
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingUnderOfferDestroy(buyerOrgId: string, listingId: string, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingUnderOfferDestroy(buyerOrgId, listingId, aaSource, options).then((request) => request(axios, basePath));
        },
        /**
         *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
         * @summary Update the details of a Listing
         * @param {string} buyerOrgId 
         * @param {string} listingId 
         * @param {ListingOrgWriteRequest} listingOrgWriteRequest 
         * @param {string} [aaSource] Internal tracking of the source of the request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgMarketplaceListingUpdate(buyerOrgId: string, listingId: string, listingOrgWriteRequest: ListingOrgWriteRequest, aaSource?: string, options?: any): AxiosPromise<ListingRead> {
            return localVarFp.orgMarketplaceListingUpdate(buyerOrgId, listingId, listingOrgWriteRequest, aaSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgMarketplaceListingAnalyticsList operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsListRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsListRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsList
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsList
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsList
     */
    readonly aaSource?: string

    /**
     * Date from. default to date_to - 13 days
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsList
     */
    readonly dateFrom?: string

    /**
     * Date to. defaults to today
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsList
     */
    readonly dateTo?: string
}

/**
 * Request parameters for orgMarketplaceListingAnalyticsSnoozeCreate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeCreateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeCreate
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingAnalyticsSnoozeDestroy operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeDestroyRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeDestroy
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeDestroy
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingArchiveCreate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingOrgArchiveRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreate
     */
    readonly listingOrgArchiveRequest: ListingOrgArchiveRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingArchiveDestroy operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingArchiveDestroyRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingArchiveDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingArchiveDestroy
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingArchiveDestroy
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingArchiveDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingBroadcastCreate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingPriceGridBroadcastRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreate
     */
    readonly listingPriceGridBroadcastRequest: ListingPriceGridBroadcastRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingCreate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingCreateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {ListingOrgWriteRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingCreate
     */
    readonly listingOrgWriteRequest: ListingOrgWriteRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingDestroy operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingDestroyRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingDestroy
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingDestroy
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingList operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingListRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingListRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly aaSource?: string

    /**
     * Listings where visibility&#x3D;PRIVATE or PUBLIC
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly live?: string

    /**
     * Filter by Network id. Multiple values must be comma separated. Use &#x60;all&#x60; to return Listings that are only shared with a Network. Use &#x60;none&#x60; to return Listing that are not associated with any networks.
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly network?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly pageSize?: number

    /**
     * Listings where visibility&#x3D;PRIVATE
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly _private?: string

    /**
     * Product
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly product?: string

    /**
     * Listings where visibility&#x3D;PUBLIC
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly _public?: string

    /**
     * Listings by the Public Status. Multiple values must be comma separated  * &#x60;DRAFT&#x60; - Draft * &#x60;REVIEW&#x60; - Under review * &#x60;REJECTED&#x60; - Rejected * &#x60;APPROVED&#x60; - Approved
     * @type {'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW'}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly publicStatus?: 'APPROVED' | 'DRAFT' | 'REJECTED' | 'REVIEW'

    /**
     * Listings that are sold
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly sold?: string

    /**
     * Listing type  * &#x60;SELL&#x60; - For sale * &#x60;BUY&#x60; - Wanted
     * @type {'BUY' | 'SELL'}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly type?: 'BUY' | 'SELL'

    /**
     * Listings that are under offer
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly underOffer?: string

    /**
     * Listing visibility. Multiple values must be comma separated. By default, if no visibility parameter is passed through, the ARCHIVED state will be excluded.  * &#x60;DELETED&#x60; - Deleted * &#x60;ARCHIVED&#x60; - Archived * &#x60;EXPIRED&#x60; - Expired * &#x60;HIDDEN&#x60; - Hidden * &#x60;PRIVATE&#x60; - Private * &#x60;PUBLIC&#x60; - Public
     * @type {'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC'}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingList
     */
    readonly visibility?: 'ARCHIVED' | 'DELETED' | 'EXPIRED' | 'HIDDEN' | 'PRIVATE' | 'PUBLIC'
}

/**
 * Request parameters for orgMarketplaceListingNotifyCreate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingNetworksNotifyRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreate
     */
    readonly listingNetworksNotifyRequest: ListingNetworksNotifyRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingOverviewRetrieve operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingOverviewRetrieveRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingOverviewRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingOverviewRetrieve
     */
    readonly buyerOrgId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingOverviewRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingPartialUpdate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdate
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdate
     */
    readonly aaSource?: string

    /**
     * 
     * @type {PatchedListingOrgWriteRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdate
     */
    readonly patchedListingOrgWriteRequest?: PatchedListingOrgWriteRequest
}

/**
 * Request parameters for orgMarketplaceListingPublishCreate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingPublishCreateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingPublishCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPublishCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPublishCreate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingPublishActionRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPublishCreate
     */
    readonly listingPublishActionRequest: ListingPublishActionRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingPublishCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingRetrieve operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingRetrieveRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingRetrieve
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingRetrieve
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingRetrieve
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingSoldCreate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingSoldCreateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingSoldCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingSoldCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingSoldCreate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingOrgSoldRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingSoldCreate
     */
    readonly listingOrgSoldRequest: ListingOrgSoldRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingSoldCreate
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingSoldDestroy operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingSoldDestroyRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingSoldDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingSoldDestroy
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingSoldDestroy
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingSoldDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingUnderOfferDestroy operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingUnderOfferDestroyRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingUnderOfferDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingUnderOfferDestroy
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingUnderOfferDestroy
     */
    readonly listingId: string

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingUnderOfferDestroy
     */
    readonly aaSource?: string
}

/**
 * Request parameters for orgMarketplaceListingUpdate operation in MarketplaceOrgListingApi.
 * @export
 * @interface MarketplaceOrgListingApiOrgMarketplaceListingUpdateRequest
 */
export interface MarketplaceOrgListingApiOrgMarketplaceListingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingUpdate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingUpdate
     */
    readonly listingId: string

    /**
     * 
     * @type {ListingOrgWriteRequest}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingUpdate
     */
    readonly listingOrgWriteRequest: ListingOrgWriteRequest

    /**
     * Internal tracking of the source of the request
     * @type {string}
     * @memberof MarketplaceOrgListingApiOrgMarketplaceListingUpdate
     */
    readonly aaSource?: string
}

/**
 * MarketplaceOrgListingApi - object-oriented interface
 * @export
 * @class MarketplaceOrgListingApi
 * @extends {BaseAPI}
 */
export class MarketplaceOrgListingApi extends BaseAPI {
    /**
     * NOTE: some data may be delayed by up to an hour
     * @summary Analytics data for the Listing
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingAnalyticsList(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsListRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingAnalyticsList(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
     * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingAnalyticsSnoozeCreate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeCreateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingAnalyticsSnoozeCreate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * POST sets setting_analytics_snoozed_until to now + 3 days. DELETE clears the snooze. While snoozed, the daily analytics SMS/push is skipped.
     * @summary Snooze (POST) or un-snooze (DELETE) analytics notifications for this listing.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingAnalyticsSnoozeDestroy(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingAnalyticsSnoozeDestroyRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingAnalyticsSnoozeDestroy(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Archive the Listing
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingArchiveCreate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingArchiveCreateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingArchiveCreate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.listingOrgArchiveRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Delete the ARCHIVED status, returning it to DRAFT.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingArchiveDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingArchiveDestroy(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingArchiveDestroyRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingArchiveDestroy(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * NOTE: A user can have the Grid bookmarked but if their visibility access changes on the grid then they will no longer be able to see it, and thus not get a notification.  eg. User is following the grid and the grid is Public, if the grid changes to Private Groups only and the user is NOT a Contact and in one of the Networks of the Org then they no longer have access and will NOT received a notification
     * @summary Broadcasts a message to the people following (bookmarked) the Listing\'s Grid
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingBroadcastCreate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingBroadcastCreateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingBroadcastCreate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.listingPriceGridBroadcastRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
     * @summary Create a new Listing
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingCreate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingCreateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingCreate(requestParameters.buyerOrgId, requestParameters.listingOrgWriteRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Deletes a Listing
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingDestroy(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingDestroyRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingDestroy(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admins can access all Listings within the Org, while regular staff members can only access the Listings they have created.  By default, if no visibility filter is passed through all ARCHIVED ones are not returned.
     * @summary Get a list of the Organisations Listings
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingList(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingListRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingList(requestParameters.buyerOrgId, requestParameters.aaSource, requestParameters.live, requestParameters.network, requestParameters.page, requestParameters.pageSize, requestParameters._private, requestParameters.product, requestParameters._public, requestParameters.publicStatus, requestParameters.sold, requestParameters.type, requestParameters.underOffer, requestParameters.visibility, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Sends a push notification out to the Users who are within the Networks passed through.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingNotifyCreate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingNotifyCreateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingNotifyCreate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.listingNetworksNotifyRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Overview of the Listings associated with the Org and User
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingOverviewRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingOverviewRetrieve(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingOverviewRetrieveRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingOverviewRetrieve(requestParameters.buyerOrgId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only the keys passed through will be updated   Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
     * @summary Partially update the details of a Listing
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingPartialUpdate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingPartialUpdateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingPartialUpdate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, requestParameters.patchedListingOrgWriteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Transition a Listing between PUBLIC and PRIVATE. It can go in either direction.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingPublishCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingPublishCreate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingPublishCreateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingPublishCreate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.listingPublishActionRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get the details of a single Listing
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingRetrieve(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingRetrieveRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingRetrieve(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Update the sold status of the listing.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingSoldCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingSoldCreate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingSoldCreateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingSoldCreate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.listingOrgSoldRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Delete the sold status.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingSoldDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingSoldDestroy(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingSoldDestroyRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingSoldDestroy(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Delete the under offer status.
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingUnderOfferDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingUnderOfferDestroy(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingUnderOfferDestroyRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingUnderOfferDestroy(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  Creating and updating Listings  # Media  ## Create  To create a new media item the ListingMediaCreate schema must be passed through in the media list as it includes the Cloudinary data.  ## Update  When updating via a PUT then all the media items need to be passed through as its updating the complete object. They need to be in the format of ListingMedia schema so that the items can be updated (order, description, cover etc). This includes the internal id.  Via a PATCH if the media key is not passed through then it is not modified. Passing through an empty value like [] will update it and remove all media.  ### Creation on update  If you would like to add a new piece of Media with an update then the ListingMediaCreate schema can be passed through and does the same as when creating media in the first place.  ### Delete media  If upon update (PUT and PATCH) a media item in the listing is no  longer present then it will be deleted.  For example, if the current media data for the Listing looks like. ```json media: [     {         \"id\": 1,         \"name\": \"image_1\",         ...     },     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` but when updating the listing and the following is passed through ``` media: [     {         \"id\": 2,         \"name\": \"image_2\",         ...     } ] ``` Then the first media item will be deleted.  
     * @summary Update the details of a Listing
     * @param {MarketplaceOrgListingApiOrgMarketplaceListingUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceOrgListingApi
     */
    public orgMarketplaceListingUpdate(requestParameters: MarketplaceOrgListingApiOrgMarketplaceListingUpdateRequest, options?: any) {
        return MarketplaceOrgListingApiFp(this.configuration).orgMarketplaceListingUpdate(requestParameters.buyerOrgId, requestParameters.listingId, requestParameters.listingOrgWriteRequest, requestParameters.aaSource, options).then((request) => request(this.axios, this.basePath));
    }
}
